import React from 'react'
import { observer } from 'mobx-react'
import { observable } from 'mobx'
import { i18nTranslate } from 'src/utils'
import { Icons } from 'src/views/components'
import { Dropdown } from 'react-bootstrap'
import './styles.scss'

@observer
class QuantityDropdown extends React.Component {
  @observable selectedQuantity = this.props.quantity
  @observable isQuantityCallInProgress = false
  componentDidUpdate = prevProps => {
    if (prevProps.quantity != this.props.quantity) {
      this.selectedQuantity = this.props.quantity
    }
  }
  handleQuantityChange = async (count, cartItemId) => {
    this.isQuantityCallInProgress = true
    const { handleCartQuantityChange } = this.props
    this.selectedQuantity = count
    const isSuccess = await handleCartQuantityChange(
      count,
      cartItemId,
      this.props
    )
    if (!isSuccess) {
      this.selectedQuantity = this.props.quantity
    }
    this.isQuantityCallInProgress = false
  }
  render() {
    const {
      // quantity,
      cartItemId,
      maxCartItemLimit,
      //isCartLimitExceed,
      isFromCart = false,
      isFromLoyalty = false,
    } = this.props
    const items = []
    const qtyCustomClass = isFromCart || isFromLoyalty ? 'ml-2' : ''
    const loyaltyCustomClass = isFromLoyalty ? 'loyalty-dropdown' : ''
    for (let count = 1; count <= maxCartItemLimit; count++) {
      const isSelectedClass = this.selectedQuantity === count ? 'selected' : ''
      items.push(
        <Dropdown.Item
          as="button"
          key={cartItemId + count}
          value={count}
          // tabIndex={0}
          className={isSelectedClass}
          onClick={event => {
            this.handleQuantityChange(count, cartItemId)
          }}
          data-testid="qa-user-sub-product-qty-option">
          {count}
        </Dropdown.Item>
      )
    }
    return (
      <div className={`quantity-dropdown-container ${loyaltyCustomClass}`}>
        <Dropdown
          className={'quantity-dropdown'}
          data-testid="qa-user-sub-product-qty-dropdown">
          <Dropdown.Toggle
            variant=""
            role="combobox"
            // id="dropdown-basic"
            disabled={this.isQuantityCallInProgress}
            className={`quantity-dropdown-toggle p-0 d-flex align-items-center ${
              !this.props.isPVAssistant
                ? 'justify-content-between'
                : 'justify-content-around'
            } quantity`}>
            <span
              className={`mb-0 ${
                this.props.transCart == 'cart' ? '' : 'pl-2'
              } ${isFromLoyalty ? 'ml-1' : ''} text-uppercase quantity-title`}
              aria-label="quantity"></span>
            <span className="selected-quantity-value">
              {this.props.isPVAssistant ? 1 : this.selectedQuantity}
            </span>
            {!this.props.isPVAssistant && (
              <span className={`quantity-dropdown-arrow ${qtyCustomClass}`}>
                <Icons
                  name="arrows"
                  icontype="downarrow"
                  alt={i18nTranslate('quantity.toggle', 'Toggle quantity box')}
                  disableicon={true}
                  ariaHidden={true}
                />
              </span>
            )}
          </Dropdown.Toggle>
          {!this.props.isPVAssistant && (
            <Dropdown.Menu className="quantity-dropdownmenu">
              {items}
            </Dropdown.Menu>
          )}
        </Dropdown>
      </div>
    )
  }
}
export { QuantityDropdown }
export default QuantityDropdown
